// extracted by mini-css-extract-plugin
export default {"root":"FutureClassesVisibility_root__J32jA","title":"FutureClassesVisibility_title__dnLR9","label":"FutureClassesVisibility_label__CtCf8"};